// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"b9dcf388","504":"9cb5fa22","686":"696bb58f","687":"8526edf9","776":"0494faba"}[chunkId] + ".chunk.css";
};